
import "./App.css";
import React from "react";
import { Col, Layout, Row } from "antd";
// import AppHeader from "./components/Appheader/Appheader";
// import {Sidebars} from './components/Sidebar/Sidebar'
import AppRoutes from "./Routes";
// import {Sidebar } from "react-pro-sidebar";
const {  Content } = Layout;

function App() {
  return (
    <Layout >
    <Row gutter={[30, 30]} className="App" >
     
      <Col span={22} offset={5} className="auth-form-container">
        <Content>
          <AppRoutes />
        </Content>
      </Col>
    </Row>
  </Layout>
  );
}

export default App;
